import React from "react";
import ReimbursementsPage from "components/common/reimbursements/ReimbursementsPage";

const Reimbursements: React.FC = () => <ReimbursementsPage />;

export default Reimbursements;
